module.exports = __webpack_public_path__ + "static/media/menuLighticon.4ff37c3f.svg";